/**
 * @file Neon cyber-arena palette (GDD §Fase 4 — dirección artística).
 *
 * Every colour in the game resolves here. Re-skinning the project means editing
 * this file and nothing else: prefabs, arena, particles and HUD all read from
 * it. Hues are chosen so that each entity class stays readable at a glance from
 * a top-down camera, and so the emissive channels feed the bloom pass without
 * washing into each other.
 */

export const PALETTE = Object.freeze({
  // Environment: almost black, so every emissive reads as a light source.
  background: 0x04060d,
  fog: 0x04060d,
  floor: 0x070a12,
  grid: 0x0c2b3c,
  wall: 0x0a1320,
  wallEdge: 0x11d9ff,
  obstacle: 0x0d1a2b,
  obstacleEdge: 0x1a6f96,

  // Player: cyan, the only cool-bright thing the player controls.
  player: 0x2ce8ff,
  playerCore: 0xe6fdff,
  playerTrail: 0x1aa8d8,
  // Exit compass: green reads as "go here" and clashes with nothing hostile.
  exitIndicator: 0x3dffa5,

  // Enemies: one hue per archetype, all warm/violet so they never read as ally.
  enemyGrunt: 0xff2f6e,
  enemyRunner: 0xff8a3d,
  enemyBrute: 0xb44bff,
  enemySpitter: 0x2bff9e,
  enemyExploder: 0xffd166,
  enemyRanged: 0x3d9cff,
  // Suicide bomber: a hot magenta-red that reads as "danger, do not touch".
  enemySuicideBomber: 0xff1f3d,
  enemyBurner: 0xff4d18,
  // Weapon-carrying variants (issue #57): armed enemies that mirror the player's
  // arsenal. Warm/violet like the rest of the roster so they never read as ally.
  enemyGunner: 0x4db8ff,
  enemyShotgunner: 0xff7a3d,
  enemySniper: 0xc04bff,
  enemyRocketeer: 0xff5c8a,
  enemyCore: 0xfff1f5,

  // Projectiles.
  bulletStandard: 0xffe066,
  bulletHeavy: 0xff9a3d,
  bulletRail: 0x9df6ff,
  bulletAcid: 0x2bff9e,
  bulletFlame: 0xff6600,
  // Rocket: the only orange-red round, so a slow missile never reads as a bullet.
  bulletRocket: 0xff4500,

  // Enemy-fired rounds (issue #57): hot magenta/red so incoming fire is instantly
  // distinct from the player's warm-yellow and cool-blue projectiles.
  enemyBulletStandard: 0xff3b6b,
  enemyBulletHeavy: 0xff6a2a,
  enemyBulletRail: 0xd94bff,
  enemyBulletRocket: 0xff2f6e,

  // Pickups.
  pickupHealth: 0x3dffa5,
  pickupShield: 0x9d7bff,
  pickupDamage: 0xff4d6d,
  pickupSpeed: 0x4dd2ff,
  pickupFireRate: 0xffcf3d,
  pickupWeapon: 0xffffff,

  // Props.
  explosiveBarrel: 0xff3333,

  // Effects.
  impact: 0xffd9a0,
  stunStar: 0xffdd00,
  explosion: 0xffb347,
  telegraph: 0xff2f6e,
  muzzle: 0xfff3c4,
  /** The "!" that pops over an enemy the moment it notices the player. */
  alert: 0xff3333,
  // Flame stream: two hues alternated per tick so the plume never reads flat.
  flame: 0xff6600,
  flameHot: 0xffaa00
});
